import React, { Fragment, useEffect, useState } from 'react';
import { hookstate, useHookstate } from '@hookstate/core';
import $ from 'jquery';
import { observer } from 'mobx-react';
import Slider from 'react-slick';

import analytics from '~/helpers/analytics';
import FacetsUtils from '~/helpers/facets_utils';
import { cuotaFormat, currencyFormat, imgFormat } from '~/helpers/formatter';
import productHelper from '~/helpers/product';
import { CrossNext, CrossPrev, iconQuestion } from '~/helpers/svg';
import { CDN, CURRENCY_SYMBOL, LOCALE, POSPAGO } from '~/store/States/global';
import { inventoryState, validateInventory as validateAllInventory } from '~/store/States/inventory';
import { getPospagoState, PAGOUNICO, pagoUnicoState, usePagoUnico } from '~/store/States/pospago';
import useStores from '~/store/StoreHook';

import { Link, withRouter } from '#/renderer/router';
import ESImIndicator from '~/components/ESimIndicator/ESimIndicator';
import SimSelection from '~/components/SimSelection/SimSelection';
import ModalNotification from '~/components/ui/ModalNotification';
import ModalNotificationConfirm from '~/components/ui/ModalNotificationConfirm';
import PagoUnicoInfo from '~/components/ui/PagoUnicoInfo';
import { InventoryModal } from '~/containers/Product/Availability';
import InventoryAlert from '~/containers/Product/InventoryAlert';
import InventoryNotify from '~/containers/Product/InventoryNotify';

import '~/sass/modules/_pospago.scss';
import '~/sass/modules/_catalogPlan.scss';

function firstOf(obj, level) {
  let myobj = obj;
  for (let i = 0; i < level; i += 1) {
    myobj = myobj[Object.keys(myobj)[0]];
  }
  return myobj;
}

function selectObj(item) {
  const attrMap = productHelper.convertAttributes(item.attributes);
  item.attrMap = attrMap;
  const name = item.locales[LOCALE].name;
  const color = attrMap['def-color'] || '';
  const size = attrMap['def-capacidad'] || '';
  const pricing = item.pricing;
  const part_number = item.part_number;
  const images = item.images || [];
  return { color, size, pricing, part_number, attrMap, name, images, item };
}

const ProductPrice = ({ pricing, attrMap, plan, plazo, precioExtra }) => {
  const { orderStore } = useStores();
  const [textoPospago, setTextoPospago] = useState();
  const [aceptaCuotas, setAceptaCuotas] = useState(false);
  const [formatoCuotas, setFormatoCuotas] = useState('');
  const [precio_minimo_incluido, setPrecio_minimo_incluido] = useState('');
  const pagoUnico = usePagoUnico();
  const pagoUState = useHookstate(pagoUnicoState);
  const isPagoUnico = pagoUState.isPagoUnico.value;
  const pric = pagoUState.pricing.value;

  useEffect(() => {
    async function init() {
      if (!orderStore.getCartConfig || !orderStore.getCartConfig.success) {
        await orderStore.getConfig();
      }
      if (orderStore.getCartConfig.success) {
        setTextoPospago(orderStore.getCartConfig.data.data.textoPospago);
        const min = orderStore.getCartConfig.data.data.precioMinimoCuotas || 0;
        setAceptaCuotas(pricing[pric][plan][plazo].offer_price >= min);
        setFormatoCuotas(orderStore.getCartConfig.data.data.formatoCuotas || '');
        if (orderStore.getCartConfig.data.data.precio_minimo_incluido) {
          setPrecio_minimo_incluido(parseFloat(orderStore.getCartConfig.data.data.precio_minimo_incluido));
        }
      }
    }
    init();
  }, [plan, plazo]);

  let currencyOffer;
  let currencyList;
  let hasPromo;
  let labelContado = '';
  let labelCuota = '';
  let labelPlan = '';
  let priceclass = '';
  let priceLabel = isPagoUnico ? pagoUnico.textos.precio : 'Precio del equipo';
  let pricePlan = 'Precio del plan';
  let contado = 'Precio de contado';
  let mostrarCuotas = true;
  let isIncluded = false;
  if (textoPospago?.terminal) {
    priceLabel = textoPospago.terminal.textoPrecio ?? priceLabel;
    pricePlan = textoPospago.terminal.textoPlan ?? pricePlan;
    contado = textoPospago.terminal.textoContado ?? contado;
    mostrarCuotas = textoPospago.terminal.mostrarCuotas ?? mostrarCuotas;
  }
  if (precioExtra !== undefined) {
    labelPlan = (
      <Fragment>
        <p className="block">{pricePlan}</p>
        <p className="price-cuota">
          <span>Al mes&nbsp;</span>
          <span className="symbol">{CURRENCY_SYMBOL}</span>
          <span>{precioExtra[0]}.</span>
          <span className="symbol">{precioExtra[1]}</span>
        </p>
      </Fragment>
    );
  }
  const getPrice = Object.keys(pricing).length;
  const cuotas = attrMap['attr-conf-pagocuotas'];
  const textoCuota = attrMap['attr-texto-cuotas'];

  if (getPrice) {
    currencyOffer = currencyFormat(pricing[pric][plan][plazo].offer_price, 1).split('.');
    currencyList = currencyFormat(pricing[pric][plan][plazo].list_price, 1).split('.');
    hasPromo = pricing[pric][plan][plazo].offer_price !== pricing[pric][plan][plazo].list_price;
  }
  if (cuotas === 'SI' && textoCuota && aceptaCuotas && mostrarCuotas) {
    if (!isPagoUnico) {
      priceLabel = attrMap['attr-titulo-cuotas'] || `${priceLabel} financiado`;
    }
    const precioCuota = parseFloat(textoCuota);
    if (Number.isNaN(precioCuota)) {
      // eslint-disable-next-line react/no-danger
      labelCuota = <p className="price-cuota" dangerouslySetInnerHTML={{ __html: textoCuota }} />;
    } else {
      const cuota = currencyFormat(
        pricing[pric][plan][plazo].offer_price / (isPagoUnico ? plazo : precioCuota),
        1,
      ).split('.');
      labelCuota = isPagoUnico
        ? cuotaFormat(cuota, plazo, pagoUnico.formatoCuotas)
        : cuotaFormat(cuota, textoCuota, formatoCuotas);
    }
    if (!isPagoUnico) {
      labelContado = <p className="price-before">{contado}</p>;
    }
    priceclass = 'cuota';
  }
  let phonePrice;
  if (currencyOffer && precio_minimo_incluido) {
    phonePrice = parseFloat(`${currencyOffer[0]}.${currencyOffer[1]}`);
    isIncluded = phonePrice <= precio_minimo_incluido;
  }
  //ACA
  const onlyOffer = (
    <div className={priceclass}>
      <h2 className="block">{priceLabel}</h2>
      {labelCuota}
      {labelContado}
      {isIncluded ? (
        <p className="price is-promo">
          <span style={{ fontSize: '1.5rem' }}>INCLUIDO</span>
        </p>
      ) : !isPagoUnico && (
        <p className="price is-promo">
          <span style={{ paddingRight: '0.5em' }} />
          <span>
            {CURRENCY_SYMBOL}
            {currencyOffer ? currencyOffer[0] : ''}.
          </span>
          <span className="symbol">{currencyOffer ? currencyOffer[1] : ''}</span>
        </p>
      )}

      {labelPlan}
    </div>
  );

  const listVsOffer = (
    <div className={priceclass}>
      <h2 className="block">{priceLabel}</h2>
      {labelCuota}
      {labelContado}
      {!isPagoUnico && (
        <>
          <p className="price is-promo">
            <span style={{ paddingRight: '0.5em' }} />
            <span>
              {' '}
              {CURRENCY_SYMBOL}
              {currencyOffer ? currencyOffer[0] : ''}.
            </span>
            <span className="symbol">{currencyOffer ? currencyOffer[1] : ''}</span>
          </p>
          <del className="price is-promo del">
            <del>
              {' '}
              {CURRENCY_SYMBOL}
              {currencyList ? currencyList[0] : ''}.
            </del>
            <del className="symbol">{currencyList ? currencyList[1] : ''}</del>
          </del>
          {labelPlan}
        </>
      )}
    </div>
  );

  return (
    <Fragment>
      {hasPromo ? listVsOffer : onlyOffer}
    </Fragment>
  );
};

//Get only Buttom
const ProductButtom = (props) => {
  const purchaseEnableds = props.isAvailable === 'available' ? (
    <a onClick={() => { props.validateCart(props.partNumber, props.plan, props.plazo); }}>
      <span>Añadir al carrito</span>
    </a>
  ) : (<p className="btn-not-available">No disponible por el momento</p>);
  const classe = 'buttom-purchases';
  return (
    <div className={classe} style={{ width: '57%' }}>
      {purchaseEnableds}
    </div>
  );
};

const ProductPurchase = (props) => {
  const attrMap = props.attributes;
  const classname = 'product--purchase';
  return (
    <section className={classname}>
      <section>
        <ProductPrice pricing={props.pricing} attrMap={attrMap} plan={props.plan} plazo={props.plazo} precioExtra={props.precioExtra} />
      </section>
    </section>
  );
};

const ProductColor = (props) => {
  const colorList = Object.entries(props.seleccion).map(([key, color]) => {
    const index = `color--${key}`;
    const colorKey = FacetsUtils.getColorsFilter(key);
    let obj;
    if (color[props.sizeInit]) {
      obj = color[props.sizeInit];
    } else if (Object.keys(color).length) {
      obj = firstOf(color, 1);
    } else {
      obj = firstOf(props.seleccion, 2);
    }
    const buyable = inventoryState.nested(obj.part_number).value > 0 ? 'item-available' : 'item-unavailable';
    return (
      <label key={index} className={buyable}>
        <input
          type="radio"
          name="product-color"
          onClick={() => {
            props.colorSelected(obj);
          }}
          checked={key === props.colorInit}
          readOnly
        />
        <i>
          <span className={`color-${colorKey}`} />
        </i>
      </label>
    );
  });

  return (
    <Fragment>
      <section className="product--color">
        <p className="product-selections">Colores:</p>
        <div>
          {colorList}
        </div>
        <InventoryAlert item={props.item} />
      </section>
    </Fragment>
  );
};

const ProductSize = (props) => {
  const sizeList = Object.entries(props.seleccion[props.colorInit]).map(([key]) => {
    const index = `size--${key}`;
    return (
      <option key={index}>
        {key}
      </option>
    );
  });

  const change = (event) => {
    let obj;
    if (props.seleccion[props.colorInit][event.target.value]) {
      obj = props.seleccion[props.colorInit][event.target.value];
    } else {
      obj = firstOf(props.seleccion[props.colorInit], 1);
    }
    props.sizeSelected(obj);
  };

  return (
    <section className="product--size">
      <p className="product-selections">Elige la capacidad:</p>
      <div className="form-select-terminal" style={{ width: '58%' }}>
        <select name="product-size" value={props.sizeInit} onChange={change}>
          {sizeList}
        </select>
      </div>
    </section>
  );
};

const ProductImage = (props) => {
  if (!props.images || !props.images.length) return null;
  //const fullname = props.name.replace(/<br(\/)?>|\\n/g, ' ');
  const alt = `${props.name} ${props.sizeInit}`;
  const images360 = (props.images || []).map((image, i) => {
    if (i > 0) return false;
    const index = i;
    const url = `${process.env.NEXT_PUBLIC_CDN_PATH}${image.replace('.jpg', '_210x180.jpg')}`;
    return (<img src={url} alt={alt} key={`img-${index}`} />);
  });
  return (
    <div className="product--image--modal">
      { images360 }
    </div>
  );
};

const FullName = (props) => {
  const fullname = props.name.replace(/<br(\/)?>|\\n/g, ' ');
  return (
    <div><h3 style={{ color: '#0197a9'/*, fontSize: '1.33333rem' */ }}>{fullname}</h3></div>
  );
};

export const ModalProduct = ({ closePopup, deletePreviousCart, name }) => {
  const fullname = name.replace(/<br(\/)?>|\\n/g, ' ');
  return (
    <ModalNotificationConfirm>
      <header>
        <i>{iconQuestion}</i>
        <h4>Confirmacion</h4>
      </header>
      <div className="cart--modal-switch_item">
        <p className="format-caption">¿Deseas sustituir los productos que ya tienes en carrito por <b>{fullname}</b>?</p>
        <nav>
          <button type="button" onClick={closePopup}><span>No</span></button>
          <button type="button" onClick={deletePreviousCart}><span>Sí</span></button>
        </nav>
        <span>Perdona la molestia pero por ahora sólo puedes comprar un tipo de producto a la vez.</span>
      </div>
    </ModalNotificationConfirm>
  );
};

const MessageProductAvailability = ({ stateAvailability, showModalAvailability }) => (
  <Fragment>
    <div className="format-caption message-movil not-stock">{stateAvailability.product_stock_category_2_message}
      <span onClick={() => showModalAvailability()} style={{ color: '#0097A9', paddingLeft: '5px', display: 'contents' }}><u>{stateAvailability.product_stock_category_2_link}</u> </span>
    </div>
  </Fragment>
);

export const selectedSimType = hookstate();

const ModalItems = ({
  closePopup,
  state,
  validateCart,
  plan,
  plazo,
  selected,
  precioExtra,
  eSimConfig,
}) => {
  const simType = useHookstate(selectedSimType);
  const eSimConfigPostpago = eSimConfig?.postpago_con_equipo;
  const esimDetail = eSimConfigPostpago?.detail;
  const pagoUState = useHookstate(pagoUnicoState);
  const isPagoUnico = pagoUState.isPagoUnico.value;

  const simTypeAttributeValue = state.attrMap['attr-conf-tipo-sim'] ? state.attrMap['attr-conf-tipo-sim'] : null;
  const canShowESimDetail = simTypeAttributeValue === 'ESIM' || simTypeAttributeValue === 'AMBAS';

  useEffect(() => {
    const optionsThatHaveSimType = ['ESIM', 'AMBAS'];
    const eSimIsAllowed = optionsThatHaveSimType.includes(simTypeAttributeValue);

    const simTypeToSet = eSimIsAllowed ? 'ESIM' : null;
    simType.set(simTypeToSet);
  }, [state.part_number]);

  return (
    <ModalNotification>
      <div>
        <header>
          <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
            <div style={{ display: 'inline-block' }}>
              <h4 style={{ fontWeight: '900', display: 'flex' }}>Selecciona opciones de equipo:</h4>
            </div>
            <div style={{ display: 'inline-block' }}>
              <button
                type="button"
                className="btn-Mpostpago"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={closePopup}
              >
                <i className="fas fa-times" />
              </button>
            </div>
          </div>
        </header>
        <p style={{ paddingBottom: '20' }} className="format-caption">
          Elige entre las opciones disponibles para completar tu plan
        </p>
      </div>
      <div className="product--main">
        <ProductImage itemInfo={state.item} images={state.images} name={state.name} sizeInit={state.size} />
        <div className="product--info" style={{ height: 'auto' }}>
          <FullName name={state.name} />
          <ProductPurchase
            partNumber={state.part_number}
            qty={1}
            validateCart={validateCart}
            pricing={state.pricing}
            attributes={state.attrMap}
            isAvailable={state.isAvailable}
            plan={plan}
            plazo={plazo}
            precioExtra={precioExtra}
          />
          {isPagoUnico && <PagoUnicoInfo />}
          <ProductColor
            colorInit={state.color}
            sizeInit={state.size}
            colorSelected={selected}
            seleccion={state.seleccion}
            item={state.item}
          />
          <ProductSize
            colorInit={state.color}
            sizeInit={state.size}
            sizeSelected={selected}
            seleccion={state.seleccion}
          />
          {canShowESimDetail && (
            <SimSelection
              esimDetail={esimDetail}
              simType={simTypeAttributeValue}
              selectedSimType={simType.get()}
              onChageSimType={(v) => {
                simType.set(v);
              }}
            />
          )}
          {state.isAvailable === 'unavailable' && (
            <>
              <InventoryNotify showAviso={false} space={false} />
              <InventoryModal item={state.item} />
            </>
          )}
        </div>

        <div className="buttom-close">
          <nav>
            <button type="button" style={{ color: '#fff' }} className="btn-modal" onClick={closePopup}>
              <span>Cerrar</span>
            </button>
          </nav>
        </div>
        <ProductButtom
          partNumber={state.part_number}
          qty={1}
          validateCart={validateCart}
          pricing={state.pricing}
          attributes={state.attrMap}
          isAvailable={state.isAvailable}
          plan={plan}
          plazo={plazo}
        />
      </div>
    </ModalNotification>
  );
};

const CrossBox = ({
  tipoProducto,
  data,
  validateCart,
  plan,
  plazo,
  disabled,
  url,
  onPrecioExtra,
  attrMap,
  todoIncluido,
}) => {
  const { orderStore } = useStores();
  const [textoPospago, setTextoPospago] = useState();
  const [aceptaCuotas, setAceptaCuotas] = useState(false);
  const [formatoCuotas, setFormatoCuotas] = useState('');
  const [precio_minimo_incluido, setPrecio_minimo_incluido] = useState('');
  const [items, setItems] = useState([]);
  const pagoUnico = usePagoUnico();
  const pagoUState = useHookstate(pagoUnicoState);
  const isPagoUnico = pagoUState.isPagoUnico.value;
  const pricing = pagoUState.pricing.value;
  let showing = false;

  useEffect(() => {
    const prodItems = { items: [...data.items] };
    productHelper.ordenar(prodItems);
    let items = prodItems.items.filter((item) => item.pricing[pricing][plan][plazo]);
    setItems(items);
  }, [data, pricing, plan, plazo]);

  useEffect(() => {
    async function init() {
      if (!orderStore.getCartConfig || !orderStore.getCartConfig.success) {
        await orderStore.getConfig();
      }
      if (orderStore.getCartConfig.success) {
        setTextoPospago(orderStore.getCartConfig.data.data.textoPospago);
        const min = orderStore.getCartConfig.data.data.precioMinimoCuotas || 0;
        setAceptaCuotas(items[0].pricing[pricing][plan][plazo].offer_price >= min);
        setFormatoCuotas(orderStore.getCartConfig.data.data.formatoCuotas || '');
        if (orderStore.getCartConfig.data.data.precio_minimo_incluido) {
          setPrecio_minimo_incluido(parseFloat(orderStore.getCartConfig.data.data.precio_minimo_incluido || 0));
        }
      }
    }
    if (items.length) {
      init();
    }
  }, [items]);

  if (items.length) {
    const item = items[0];
    if (!item.pricing[pricing]?.[plan]?.[plazo]) {
      return null;
    }
    const hasPromo = item.pricing[pricing][plan][plazo].offer_price !== item.pricing[pricing][plan][plazo].list_price;
    const atributesMap = productHelper.convertAttributes(item.attributes);
    const cuotas = atributesMap['attr-conf-pagocuotas'];
    const textoCuota = atributesMap['attr-texto-cuotas'];
    let label = isPagoUnico ? pagoUnico?.textos.precio : 'Precio';
    let labelContado = '';
    let labelCuota = '';
    let labelPlan = 'Precio plan';
    let contado = 'Precio de contado';
    let mostrarCuotas = true;
    if (textoPospago?.terminal) {
      label = textoPospago.terminal.textoPrecio ?? label;
      labelPlan = textoPospago.terminal.textoPlan ?? labelPlan;
      contado = textoPospago.terminal.textoContado ?? contado;
      mostrarCuotas = textoPospago.terminal.mostrarCuotas ?? mostrarCuotas;
    }
    let paymentLabel = hasPromo ? 'OFERTA' : atributesMap['attr-texto-precio'];
    let priceclass = 'cross--box--price';
    if (cuotas === 'SI' && textoCuota && aceptaCuotas && mostrarCuotas) {
      if (!isPagoUnico) {
        label = atributesMap['attr-titulo-cuotas'] || `${label} financiado`;
      }
      const precioCuota = parseFloat(textoCuota);
      if (Number.isNaN(precioCuota)) {
        // eslint-disable-next-line react/no-danger
        labelCuota = <p className="price-cuota" dangerouslySetInnerHTML={{ __html: textoCuota }} />;
      } else {
        const cuota = currencyFormat(
          item.pricing[pricing][plan][plazo].offer_price / (isPagoUnico ? plazo : precioCuota),
          1,
        ).split('.');
        labelCuota = isPagoUnico
          ? cuotaFormat(cuota, plazo, pagoUnico?.formatoCuotas)
          : cuotaFormat(cuota, textoCuota, formatoCuotas);
      }
      if (hasPromo) {
        labelContado = <p className="price-before">{contado}</p>;
      } else {
        paymentLabel = contado;
      }
      priceclass = 'cross--box--price cuota';
    }
    const currencyText = currencyFormat(item.pricing[pricing][plan][plazo].offer_price, 1).split('.');
    const image = item.images?.[0] ? `${CDN}${item.images[0]}` : '/media/layout/noimage.jpg';
    const fullname =
      item.locales?.[LOCALE].name
        .replace(/<br>|<br\/>|\\n/g, '\n')
        .split('\n')
        .map((str, idx) => <span key={idx}>{str}</span>) ?? '';

    if (precio_minimo_incluido) {
      showing = item.pricing[pricing][plan][plazo].offer_price <= precio_minimo_incluido;
    }
    if (tipoProducto !== POSPAGO) {
      let onProductClick;
      let validate = async () => {
        let itemList = items;
        if (items.length > 1){
          const { available, unavailable } = await validateAllInventory(items);
          itemList = available.concat(unavailable);
          setItems(itemList);
        }
        validateCart(item.part_number, plan, plazo, item.locales[LOCALE].name, itemList);
      };
      let labelPlanPrecio;
      let className = '';
      if (todoIncluido) {
        onProductClick = validate;
        validate = undefined;
      } else {
        className = 'pospago';
        const precioExtra = currencyFormat(
          (item.pricing[pricing][plan][plazo].financing || 0) / plazo + +attrMap['attr-conf-precio-mensual'],
          1,
        ).split('.');
        onProductClick = (e) => {
          $('.cross--box.pospago').removeClass('hover').addClass('no-hover');
          $(e.target).closest('.cross--box.pospago').removeClass('no-hover').addClass('hover');
          onPrecioExtra(precioExtra);
        };
        labelPlanPrecio = (
          <Fragment>
            <b>{labelPlan}</b>
            <p className="price-cuota">
              <span>Al mes&nbsp;</span>
              <span className="symbol">{CURRENCY_SYMBOL}</span>
              <span>{precioExtra[0]}.</span>
              <span className="symbol">{precioExtra[1]}</span>
            </p>
          </Fragment>
        );
      }
      return (
        <article className={`cross--box ${className}`} onClick={onProductClick} style={{ position: 'relative' }}>
          <a>
            <h3>{fullname}</h3>
            {data.hasVarianWithEsim && data.esimIndicator && (
              <ESImIndicator label={data.esimIndicator.label} image={data.esimIndicator.image} top={116} />
            )}
            <picture>
              <img src={imgFormat('210x180', image)} alt="crossImage" />
            </picture>
            <section className={priceclass}>
              <b>{label}</b>
              {labelCuota}
              {!isPagoUnico && labelContado}
              {!isPagoUnico && <p className="price-before">{paymentLabel}</p>}
              {/* <p className="price">
                <span className="symbol">{process.env.NEXT_PUBLIC_CURRENCY_SYMBOL}</span>
                <span>{(currencyText ? currencyText[0] : '')}.</span>
                <span className="symbol">{(currencyText ? currencyText[1] : '')}</span>
              </p> */}
              {showing && !paymentLabel ? (
                <p className="price" style={{ fontSize: '1.5rem' }}>
                  <span>INCLUIDO</span>
                </p>
              ) : !isPagoUnico && (
                <p className="price">
                  <span className="symbol">{CURRENCY_SYMBOL}</span>
                  <span>{currencyText ? currencyText[0] : ''}.</span>
                  <span className="symbol">{currencyText ? currencyText[1] : ''}</span>
                </p>
              )}
              {labelPlanPrecio}
            </section>
            {disabled[item.part_number] ? (
              <b className="product--purchase link-box" onClick={validate}>
                <span>No disponible por el momento</span>
              </b>
            ) : (
              <b className="add link-box" onClick={validate}>
                <span>Comprar</span>
              </b>
            )}
          </a>
        </article>
      );
    } else {
      let query = '';
      if (isPagoUnico) {
        query = `?tipo=${PAGOUNICO}`;
      }
      return (
        <article className="cross--box" style={{ position: 'relative' }}>
          <Link to={`/productp/${item.locales[LOCALE].seo.name}/${url}${query}`}>
            <h3>{fullname}</h3>
            {data.hasVarianWithEsim && data.esimIndicator && (
              <ESImIndicator label={data.esimIndicator.label} image={data.esimIndicator.image} top={116} />
            )}
            <picture>
              <img src={imgFormat('210x180', image)} alt="crossImage" />
            </picture>
            <section className={priceclass}>
              <b>{label}</b>
              {labelCuota}
              {!isPagoUnico && labelContado}
              {!isPagoUnico && <p className="price-before">{paymentLabel}</p>}
              {/* <p className="price">
                <span className="symbol">{process.env.NEXT_PUBLIC_CURRENCY_SYMBOL}</span>
                <span>{(currencyText ? currencyText[0] : '')}.</span>
                <span className="symbol">{(currencyText ? currencyText[1] : '')}</span>
              </p>*/}
              {showing && !paymentLabel ? (
                <p className="price" style={{ fontSize: '1.5rem' }}>
                  <span>INCLUIDO</span>
                </p>
              ) : !isPagoUnico && (
                <p className="price">
                  <span className="symbol">{CURRENCY_SYMBOL}</span>
                  <span>{currencyText ? currencyText[0] : ''}.</span>
                  <span className="symbol">{currencyText ? currencyText[1] : ''}</span>
                </p>
              )}
            </section>
            <b>
              <span>Ver más</span>
            </b>
          </Link>
        </article>
      );
    }
  }
  return null;
};

const Cross = observer((props) => {
  const { catalogStore, modals, orderStore } = useStores();
  const [state, replaceState] = useState({
    products: [],
    disabled: {},
    newItem: {},
  });
  const pagoUState = useHookstate(pagoUnicoState);
  const isPagoUnico = pagoUState.isPagoUnico.value;

  const [esimIndicator, setEsimIndicator] = useState(null);
  const [eSimConfig, setESimConfig] = useState(null);

  useEffect(() => {
    async function init() {
      const getEsimConfig = await orderStore.getConfigEsim();

      if (getEsimConfig.success) {
        const eSimConfigToSet = getEsimConfig.data.data;
        const esimIndicatorToSet = eSimConfigToSet.esimIndicator;
        setEsimIndicator(esimIndicatorToSet);
        setESimConfig(eSimConfigToSet);
      }
    }
    init();
  }, []);

  const setState = data => replaceState(prevState => ({ ...prevState, ...data }));

  const closePopup = () => {
    modals.closePopup();
    setState({
      PPopup: modals.PPopup,
      popupItems: false,
      popupCart: false,
    });
  };

  const selected = async (obj, inv = true) => {
    const [inventoryStatus] = await Promise.all([
      inv && catalogStore.inventoryStatusService(obj.part_number),
    ]);
    let status = 'unavailable';
    if (props.allProps.isAvailable === 'available') {
      if (inventoryStatus && inventoryStatus.data?.data) {
        status = inventoryStatus.data.data.status;
        inventoryState
          .nested(obj.part_number)
          .set(inventoryStatus.data.data.buyable ? inventoryStatus.data.data.quantity : 0);
      } else if (!inv && inventoryState.nested(obj.part_number).value > 0) {
        status = 'available';
      }
    }

    setState({ ...obj, isAvailable: status });
    if (!props.allProps.todoIncluido) {
      const precioExtra = currencyFormat(((obj.pricing[props.pricing][props.part_number][props.plazo].financing || 0) / props.plazo) + +props.attrMap['attr-conf-precio-mensual'], 1).split('.');
      props.onPrecioExtra(precioExtra);
    }
  };

  const addToCart = async (partNumber, plan, orderInfo, modaStatus) => {
    let init = 'user_warned';

    if (orderInfo && !orderInfo.success) {
      init = 'user_not_warned';
    }

    const terminalPayload = {
      part_number: partNumber,
      quantity: 1,
      esim: selectedSimType.get() === 'ESIM',
    };
    const response = await orderStore.addToCart(terminalPayload, init);
    const response2 = await orderStore.addToCart({ part_number: plan, quantity: 1 }, init);

    if (response.success && response2.success) {
      analytics.addToCart(response2.data.data, partNumber);
      if (!modaStatus) {
        closePopup();
        props.history.push('/cart');
      }
    }

    return response;
  };

  const deletePreviousCart = async () => {
    closePopup();
    const { newItem } = state;
    const cart = orderStore.getCartInfo.data.data;
    let success = true;
    for (let i = 0; i < cart.items.length; i += 1) {
      const item = cart.items[i];
      const res = await orderStore.deleteToCart(item.part_number);
      success = success && res.success;
      if (res.success) {
        analytics.removeFromCart(cart, item.part_number);
      }
    }
    if (success) {
      await addToCart(newItem.partNumber, newItem.plan, newItem.orderInfo);
    } else {
      alert('Ha ocurrido un error.');
    }
  };

  const validateInventory = async (part_number) => {
    const [inventoryStatus] = await Promise.all([
      catalogStore.inventoryStatusService(part_number),
    ]);
    let status = true;
    if (inventoryStatus && inventoryStatus.data && inventoryStatus.data.data) {
      status = inventoryStatus.data.data.status !== 'available' || props.allProps.isAvailable !== 'available';
    }
    setState({ disabled: { ...state.disabled, [part_number]: status } });
  };

  const validateCart = async (item_part_number, plan, plazo, name, items = []) => {
    const hasAtLeadOneVariantWithAttributeEsim = items.some((item) => {
      const attrConfigEsim = item.attributes.find(a => a?.identifier === 'attr-conf-esim');
      return attrConfigEsim?.value === 'SI';
    });

    const showModal = () => {
      const seleccion = {};
      let obj;
      items.forEach((it, i) => {
        const attrs = productHelper.convertAttributes(it.attributes);
        const color = attrs['def-color'] || '';
        const size = attrs['def-capacidad'] || '';
        if (!seleccion[color]) {
          seleccion[color] = {
            [size]: selectObj(it),
          };
        } else if (!seleccion[color][size]) {
          seleccion[color][size] = selectObj(it);
        }
        if (i === 0) {
          obj = seleccion[color][size];
        }
      });
      modals.openPopup('cart');
      selected({ ...obj, seleccion, popupItems: true }, items.length <= 1);
    };
    // abrir modal auque solo tenga un item pero que al menos uno tenga esim
    if (items.length > 1 || (hasAtLeadOneVariantWithAttributeEsim && items.length === 1)) {
      showModal();
    } else {
      const [orderInfo, inventoryStatus] = await Promise.all([
        orderStore.getCart(),
        catalogStore.inventoryStatusService(item_part_number),
      ]);
      let status = false;
      if (inventoryStatus?.data?.data) {
        status = inventoryStatus.data.data.status === 'available' && props.allProps.isAvailable === 'available';
        inventoryState.nested(item_part_number).set(inventoryStatus.data.data.buyable ? inventoryStatus.data.data.quantity : 0);
      }
      if (status) {
        let partNumber = `${item_part_number}--${plan}--${plazo}`;
        if (isPagoUnico) {
          partNumber = `${partNumber}--T`;
        }
        if (orderInfo && !orderInfo.success) {
          return addToCart(partNumber, plan, orderInfo);
        } else if (orderInfo.data && orderInfo.data.data) {
          let total = 0;
          if (orderInfo.data && orderInfo.data.data && orderInfo.data.data.items.length) {
            total = 1;
          }

          if (total > 0) {
            modals.openPopup('cart');
            setState({
              popupCart: true,
              popupItems: false,
              PPopup: modals.PPopup,
              newItem: { partNumber, plan, orderInfo, name: `${props.allProps.name} y ${name || state.name}` },
            });
          } else {
            return addToCart(partNumber, plan, orderInfo, false);
          }
        }
      } else {
        setState({ disabled: { ...state.disabled, [item_part_number]: true } });
        showModal();
      }
    }
    return false;
  };

  useEffect(() => {
    async function init() {
      const pricing = pagoUState.pricing.value;
      const [pospago] = await Promise.all([
        catalogStore.pospago({ part_number: props.part_number, tipo_oferta: pricing }),
      ]);
      if (pospago.success) {
        const pospagoState = await getPospagoState();
        const products = pospago.data.filter((prod) => {
          prod.itemsFilter = prod.items.filter(it => it.available && it.pricing[pricing]?.[props.part_number] && it.part_number !== pospagoState.config.product_sku_sin_equipo.value);
          return prod.itemsFilter.length;
        }).sort((prod1, prod2) => {
          const pos1 = prod1.itemsFilter.sort((it1, it2) => (it1.pricing[pricing][props.part_number]?.[props.plazo]?.position ?? 1000) - (it2.pricing[pricing][props.part_number]?.[props.plazo]?.position ?? 1000))[0]?.pricing[pricing][props.part_number]?.[props.plazo]?.position ?? 1000;
          const pos2 = prod2.itemsFilter.sort((it1, it2) => (it1.pricing[pricing][props.part_number]?.[props.plazo]?.position ?? 1000) - (it2.pricing[pricing][props.part_number]?.[props.plazo]?.position ?? 1000))[0]?.pricing[pricing][props.part_number]?.[props.plazo]?.position ?? 1000;
          return pos1 - pos2;
        });
        const cross = products.filter((prod) => {
          prod.items = prod.itemsFilter.filter(it => it.pricing[pricing][props.part_number][props.plazo]);
          return prod.items.length;
        }).map((x) => {
          const hasAtLeadOneVariantWithAttributeEsim = x.items.some((item) => {
            const attrConfigEsim = item.attributes.find(a => a?.identifier === 'attr-conf-esim');
            return attrConfigEsim?.value === 'SI';
          });

          return ({
            ...x,
            hasVarianWithEsim: hasAtLeadOneVariantWithAttributeEsim,
            esimIndicator: hasAtLeadOneVariantWithAttributeEsim ? esimIndicator : null,
          });
        }).map(obj => (
          <CrossBox
            tipoProducto={props.tipoProducto}
            data={obj}
            key={obj.part_number}
            url={obj.part_number}
            validateCart={validateCart}
            plan={props.part_number}
            plazo={props.plazo}
            disabled={state.disabled}
            validateInventory={validateInventory}
            onPrecioExtra={props.onPrecioExtra}
            attrMap={props.attrMap}
            todoIncluido={props.allProps.todoIncluido}
          />
        ));
        const crossSettings = {
          infinite: cross.length > 4,
          autoplay: false,
          autoplaySpeed: 4000,
          dots: false,
          speed: 500,
          // centerMode: true,
          slidesToScroll: 1,
          slidesToShow: 4,
          pauseOnHover: true,
          // initialSlide: 1,
          arrows: true,
          prevArrow: <CrossPrev />,
          nextArrow: <CrossNext />,
          /* responsive: [{
            breakpoint: 991,
            settings: 'unslick',
          }],*/
          responsive: [{
            breakpoint: 760,
            settings: {
              slidesToShow: 2,
              infinite: false,
              dots: true,
            },
          }, {
            breakpoint: 560,
            settings: {
              slidesToShow: 1,
              infinite: false,
              //centerPadding: '100px',
              dots: true,
            },
          },
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 4,
              infinite: false,
              dots: true,
            },
          }],
          // responsive: [{
          //   breakpoint: 760,
          //   settings: {
          //     slidesToShow: 2,
          //   },
          // }, {
          //   breakpoint: 1024,
          //   settings: {
          //     slidesToShow: 4,
          //   },
          // }, {
          //   breakpoint: 1800,
          //   settings: {
          //     slidesToShow: 5,
          //   },
          // }],
        };
        setState({ products, crossSettings, cross });
      }
    }
    if (props.part_number) {
      init();
    }
  }, [props.part_number]);

  useEffect(() => {
    const pricing = pagoUState.pricing.value;
    const cross = state.products.filter((prod) => {
      prod.items = prod.itemsFilter.filter(it => it.pricing[pricing][props.part_number][props.plazo]);
      return prod.items.length;
    }).map((x) => {
      const hasAtLeadOneVariantWithAttributeEsim = x.items.some((item) => {
        const attrConfigEsim = item.attributes.find(a => a?.identifier === 'attr-conf-esim');
        return attrConfigEsim?.value === 'SI';
      });

      return ({
        ...x,
        hasVarianWithEsim: hasAtLeadOneVariantWithAttributeEsim,
        esimIndicator: hasAtLeadOneVariantWithAttributeEsim ? esimIndicator : null,
      });
    }).map(obj => (
      <CrossBox
        tipoProducto={props.tipoProducto}
        data={obj}
        key={obj.part_number}
        url={obj.part_number}
        validateCart={validateCart}
        plan={props.part_number}
        plazo={props.plazo}
        disabled={state.disabled}
        validateInventory={validateInventory}
        onPrecioExtra={props.onPrecioExtra}
        attrMap={props.attrMap}
        todoIncluido={props.allProps.todoIncluido}
      />
    ));
    setState({ cross, crossSettings: { ...state.crossSettings, infinite: cross.length > 4 } });
  }, [props.plazo, state.products, state.disabled]);

  const [planTitle, setPlanTitle] = useState();
  useEffect(() => {
    async function init() {
      if (!orderStore.getCartConfig || !orderStore.getCartConfig.success) {
        await orderStore.getConfig();
      }
      if (orderStore.getCartConfig.success) {
        setPlanTitle(orderStore.getCartConfig.data.data.planTitle);
      }
    }
    init();
  }, []);

  let title;
  if (props.tipoProducto === 'POSPAGO') {
    title = 'Otros usuarios también vieron';
  } else {
    title = planTitle || 'Lleva tu equipo con tu Plan Postpago';
  }
  return state.products.length > 0 && (
    <Fragment>
      <section className="cross cross--pospago">
        <div className="cross--module">
          <h2 id="planCrossTitle">{title}</h2>
          <div className="slick--cross">
            <Slider {...state.crossSettings}>
              {state.cross}
            </Slider>
          </div>
          {/*crossResponsive*/}

        </div>
        {
          state.popupItems
          && modals.PPopup
          && (
            <ModalItems
              closePopup={closePopup}
              state={state}
              validateCart={validateCart}
              plan={props.part_number}
              plazo={props.plazo}
              selected={selected}
              name={state.newItem.name}
              precioExtra={props.allProps.precioExtra}
              eSimConfig={eSimConfig}
            />
          )
        }
        {
          state.popupCart
          && modals.PPopup
          && (
            <ModalProduct
              closePopup={closePopup}
              name={state.newItem.name}
              deletePreviousCart={deletePreviousCart}
            />
          )
        }
      </section>
    </Fragment>
  );
});

export default withRouter(Cross);
